import { BoxProps, Column, ColumnProps } from "@hightouch/htui";
import { LoaderText } from "./loader-text";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren<ColumnProps> & {
  textProps?: Omit<BoxProps, "as" | "children" | "color">;
};

export function GraphWithLoaderText({ children, textProps, ...props }: Props) {
  return (
    <Column
      align="start"
      justify="start"
      gap={8}
      pt={2}
      w="100%"
      overflow="hidden"
      {...props}
    >
      <LoaderText {...textProps} />
      {children}
    </Column>
  );
}
